/**
 * Función hecha con la intención de que se exporte y se utilice sobre todo
 * módulo que requiera realizar una búsqueda por coincidencia de texto.
 * 
 * @param:  input. Texto que ha sido introducido como búsqueda
 *          option. Opciones sobre las que se realizará el filtrado
 * @return: boolean. Indica si input se encuentra en option.
 */
let sanitizerTexto = (input, option) => {
    return  option.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .trim().toLowerCase().includes(input.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "").trim().toLowerCase())
}

export {sanitizerTexto};